import { useState, useRef, useEffect } from 'react'
import icon from "../../assets/images/144x.png";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useUser } from 'hooks';
import { logout } from 'providers/userSlice';
import { hide } from 'providers/toastSlice';
import { getFirstCharacter } from 'components/misc/functions';
import { HugeiconsIcon } from '@hugeicons/react';
import { Menu01Icon, Cancel01Icon, UserCircleIcon, Logout01Icon, LayoutLeftIcon } from '@hugeicons/core-free-icons';

function Topbar() {
    const { user } = useUser();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [userOpen, setUserOpen] = useState(false);
    const userRef = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (userRef.current && !userRef.current.contains(e.target)) setUserOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const toggleMobileMenu = () => {
        setMobileOpen(o => !o);
        const sidebar = document.getElementById('sidebar-mobile');
        if (sidebar) {
            if (sidebar.classList.contains('hidden') || sidebar.classList.contains('hide-mobile-menu')) {
                sidebar.classList.remove('hidden');
                sidebar.classList.remove('hide-mobile-menu');
            } else {
                sidebar.classList.add('hide-mobile-menu');
            }
        }
    };

    const handleLogout = () => {
        setUserOpen(false);
        navigate('/login', { replace: true });
        dispatch(logout());
        dispatch(hide());
    };

    const initials = `${getFirstCharacter(user?.otherNames)}${getFirstCharacter(user?.surname)}`;

    return (
        <nav className='fixed z-30 w-full bg-white dark:bg-dark-page border-b border-gray-200 dark:border-white/[.08]'>
            <div className='px-4 h-14 flex items-center justify-between'>

                {/* Left: desktop sidebar toggle + mobile hamburger + logo */}
                <div className="flex items-center gap-2">
                    {/* Desktop: toggle sidebar */}
                    <button
                        className='hidden lg:flex p-2 rounded-lg text-gray-500 dark:text-white/80 hover:text-gray-700 hover:bg-gray-100 transition-colors'
                        onClick={() => window.dispatchEvent(new CustomEvent('toggle-sidebar'))}
                        title="Toggle sidebar"
                        aria-label="Toggle sidebar"
                    >
                        <HugeiconsIcon icon={LayoutLeftIcon} size={20} />
                    </button>

                    {/* Mobile: hamburger */}
                    <button
                        className='lg:hidden p-2 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors'
                        onClick={toggleMobileMenu}
                        aria-label="Toggle menu"
                    >
                        <HugeiconsIcon icon={mobileOpen ? Cancel01Icon : Menu01Icon} size={20} />
                    </button>

                    <Link to='/' title='Home' className='flex items-center gap-2'>
                        <img src={icon} alt='CedisPay' className='w-7 h-7 rounded-full' />
                        <span className='font-semibold text-sm text-gray-800 dark:text-white/80 uppercase tracking-wide hidden sm:block'>CedisPay</span>
                    </Link>
                </div>

                {/* Right: user avatar dropdown */}
                <div ref={userRef} className="relative">
                    <button
                        onClick={() => setUserOpen(o => !o)}
                        className='w-8 h-8 rounded-full bg-[#1e3a6e] flex items-center justify-center text-white text-xs font-bold hover:opacity-90 transition-opacity'
                        aria-label="User menu"
                    >
                        {initials}
                    </button>

                    {userOpen && (
                        <div className="absolute right-0 top-full mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-50">
                            <div className="px-4 py-3 border-b border-gray-100">
                                <p className="text-sm font-semibold text-gray-900 truncate">
                                    {user?.otherNames} {user?.surname}
                                </p>
                                <p className="text-xs text-gray-500 truncate mt-0.5">{user?.email}</p>
                            </div>

                            <div className="py-1">
                                <Link
                                    to="/profile"
                                    onClick={() => setUserOpen(false)}
                                    className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors"
                                >
                                    <HugeiconsIcon icon={UserCircleIcon} size={16} className="text-gray-400" />
                                    Profile
                                </Link>
                            </div>

                            <div className="border-t border-gray-100 py-1">
                                <button
                                    onClick={handleLogout}
                                    className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors"
                                >
                                    <HugeiconsIcon icon={Logout01Icon} size={16} className="text-red-500" />
                                    Sign out
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
}

export default Topbar;
